import React, { useState } from 'react'
import { Wrapper } from '../style'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { PlanTypes } from 'src/redux/types/planTypes'
import { ModalButton } from 'src/components/Global/Button/Button'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ModalTitleText } from 'src/components/Global/Text/TitleText'
import useSnackbar from 'src/hooks/useSnackBar'
import { useNavigate } from 'react-router'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import { useTypedSelector } from 'src/redux'
import { updatePlanAction } from 'src/redux/actions/planAction'

const ExtendDate = () => {
  let today = new Date()
  const plan = useTypedSelector((state) => state.userPlanReducer.getPlansById)
  const { plan_type } = plan
  let date =
    today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
  const [planData, setPlanData] = useState({
    start_date: date,
    maturity_date: '',
    timeline: '',
  })

  const TIMELINE = [
    {
      code: '1',
      name: '1 Month',
    },
    {
      code: '2',
      name: '2 Months',
    },
    {
      code: '3',
      name: '3 Months',
    },
    {
      code: '4',
      name: '4 Months',
    },
    {
      code: '6',
      name: '6 Months',
    },
    {
      code: '12',
      name: '1 Year',
    },
    {
      code: '24',
      name: '2 Year',
    },
  ]
  const dispatch = useDispatch()

  const createPlan = (e: any) => {
    e.preventDefault()
    setLoading(true)
    if (!planData.timeline) {
      toast.warn('Timeline can not be empty!', {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      return
    }
    plan.maturity_date = planData.maturity_date
    dispatch(updatePlanAction({ plan, onSuccess, onError }))
  }
  const [loading, setLoading] = useState(false)

  const [active, setActive] = useState('')
  const someFunct = (item: any, code: any) => {
    setActive(item)
    console.log(code)
    planData.maturity_date = addMonths(new Date(), code)
    planData.timeline = item
    dispatch(action(PlanTypes._UPDATE_PLAN_FORM, planData))
  }
  const addMonths = (date: any, months: any) => {
    var d = date.getDate()
    date.setMonth(date.getMonth() + +months)
    if (date.getDate() !== d) {
      date.setDate(0)
    }
    return (
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    )
  }
  const Disabled = () => {
    if (!planData.timeline) {
      return 'blur'
    }
    return null
  }
  const snackbar = useSnackbar()
  const navigate = useNavigate()

  const onSuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
    setTimeout(() => {
      if (plan_type === 'general') {
        navigate(-1)
      }
      if (plan_type === 'target') {
        navigate(-1)
      }
    }, 1500)
  }

  const onError = (error: any) => {
    setLoading(false)
    snackbar.trigger({
      message: 'Error updating Your Plan',
      severity: 'error',
    })
  }
  return (
    <Wrapper>
      <div className="pageNumber"></div>
      <form className="content">
        <div className="top-form">
          <ModalTitleText>Timeline</ModalTitleText>
          <div className="line">
            {TIMELINE.map(function (name, index) {
              return (
                <input
                  type="button"
                  className={active === name.name ? 'active time' : 'time'}
                  value={name.name}
                  onClick={() => someFunct(name.name, name.code)}
                  key={name.code}
                />
              )
            })}
          </div>
        </div>

        <div>
          <ModalButton onClick={createPlan} className={`button ${Disabled()}`}>
            Update {loading && <Spinner />}
          </ModalButton>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </form>
    </Wrapper>
  )
}

export { ExtendDate }
